module.exports = __webpack_public_path__ + "images/crest07e615ba33e0a8658c794622e3352454.png";